import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../data/content";
import { Reveal } from "../components/Reveal";

export default function FAQ() {
  return (
    <section className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="container-x grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-28">
            <Reveal>
              <p className="font-heading font-bold uppercase tracking-[0.2em] text-sm text-[#0033A2] mb-4">
                FAQ
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading font-extrabold tracking-tight text-4xl md:text-5xl leading-[0.95]">
                Questions? We've got answers.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-black/60 font-medium leading-relaxed">
                Still curious? Reach us at{" "}
                <a href="mailto:hello@grooh.app" className="text-[#0033A2] font-bold underline">
                  hello@grooh.app
                </a>
              </p>
            </Reveal>
          </div>
        </div>

        <div className="md:col-span-7">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b-2 border-black"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-heading font-bold text-left text-xl md:text-2xl tracking-tight hover:no-underline data-[state=open]:text-[#0033A2] py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-black/70 font-medium text-base md:text-lg leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
